module.exports = __webpack_public_path__ + "img/awards9.2ce81008.svg";